import {FETCH_VENDOR_DATA_FAILURE,FETCH_VENDOR_DATA_SUCCESS} from './action';

const initialState = {
    vendorDataFile: null,
    vendorDataError: null
}

const vendorDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_VENDOR_DATA_SUCCESS:
            return state = {
                ...state,
                vendorDataFile: action.data
            }
        case FETCH_VENDOR_DATA_FAILURE:
            return state = {
                
                ...state,
                vendorDataError: action.error
            }
        default: return state
    }
}
export default vendorDataReducer;